// Back into an editor after a refused value (the big red message, "OK, I'll fix it"): the focus in
// it and all its text selected, so the next keystroke replaces the refused value instead of adding
// to it. One place for the Worklist's cells, the Shipping schedule's and the dialogs'. No imports:
// `scripts/routing-checks.ts` checks it.

/** What an editor's input is to it: an `HTMLInputElement`, or the checks' stand-in. */
export interface Refocusable {
  focus(): void;
  select(): void;
}

/** On the next frame, once the message has closed and given the focus back. */
export function refocusEditor(
  input: Refocusable | null | undefined,
  frame: (run: () => void) => void = requestAnimationFrame,
): void {
  frame(() => {
    if (!input) return;
    input.focus();
    input.select();
  });
}
